import AoneService from "../axiosbase";
//get complaint
export const getComplaints = async (data) => {
    try  {
        return await AoneService.post(`cs/api/v2/complaints/filter`, data)
    } catch (error) {
        return error;
    }
}
//post complaint
export const postComplaints = async (data) => {
    try {
      return await AoneService.post(`cs/api/v1/complaint`,data);
    } catch (error) {
      return error;
    }
  };

//get complaint by id
export const getComplaintsbyId = async (params) => {
    try {
      return await AoneService.get(`cs/api/v1/complaint?id=${params}`);
    } catch (error) {
      return error;
    }
  };
//delete complaint
export const deleteComplaints = async (params) => {
    try {
      return await AoneService.delete(`cs/api/v1/complaint?id=${params}`);
    } catch (error) {
      return error;
    }
  };
//resolve complaint
  export const resolveComplaints = async (data) => {
    try {
      return await AoneService.post(`cs/api/v1/complaint/resolve`,data);
    } catch (error) {
      return error;
    }
  };
  //close complaint
    export const closeComplaints = async (params) => {
    try {
      return await AoneService.post(`cs/api/v1/complaint/closed?id=${params}`);
    } catch (error) {
      return error;
    }
  };
    //reject complaint
    export const rejectComplaints = async (params) => {
    try {
      return await AoneService.post(`cs/api/v1/complaint/reject?id=${params}`);
    } catch (error) {
      return error;
    }
  };
  //edit complaint
  export const editComplaints = async (data) => {
    try {
      return await AoneService.put(`cs/api/v1/complaint`,data);
    } catch (error) {
      return error;
    }
  };
  //export complaints
  export const exportComplaints = async (params) => {
  try {
    return await AoneService.get(`cs/api/v1/complaint/export${params}`, {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};
//lookup-tool
export const getComplaintChannel = async () => {
    try {
      return await AoneService.get(`cs/api/v1/lookups/ComplaintChannelEnum`);
    } catch (error) {
      return error;
    }
  };
// complaintunit-lookup
export const getComplaintStatus = async () => {
    try {
      return await AoneService.get(`cs/api/v1/lookups/ComplaintStatusEnum`);
    } catch (error) {
      return error;
    }
  };
  //Dimension Unit
  export const getComplaintType = async () => {
    try {
      return await AoneService.get(`cs/api/v1/lookups/ComplaintTypeEnum`);
    } catch (error) {
      return error;
    }
  };
  //Investigation
  //send investigation message or proof
export const postInvestigationMessage = async (formData) => {
  try {
    return await AoneService.post(
      `cs/api/v1/investigation/send`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" }, // optional, Axios can handle
      }
    );
  } catch (error) {
    return error;
  }
};

  //get complaint investigation details
export const getComplaintInvestigation = async (params) => {
    try  {
        return await AoneService.get(`cs/api/v1/investigation?complaintId=${params}`)
    } catch (error) {
        return error;
    }
}
  //download investigation proof attachment with google file id
  export const downloadInvestigationProof = async (params) => {
    try {
      return await AoneService.get(`cs/api/v1/investigation/${params}/download`,
      {
       responseType: "blob"
      }
    );
    } catch (error) {
      return error;
    }
  };
